import React, { useEffect, useState } from 'react';
import { ForgotPassword } from '@milkmoovement/common_cognito_package';
import { useHistory } from 'react-router-dom';
import { getRegion } from '../../../../utils';
import { fetchAuthConfigFromBackend } from '../../../../utils/regionConfig';

const ForgotPasswordPage = () => {
    const [region, setRegion] = useState(sessionStorage.getItem('mm.auth.region'));
    const [coreSystem, setCoreSystem] = useState(sessionStorage.getItem('mm.auth.coreSystem'));
    const [isLoadingRegion, setIsLoadingRegion] = useState(true);
    const subdomain = window.location.href.split('#')[0];
    const history = useHistory();

    // Fetch region from backend on component mount
    useEffect(() => {
        const loadRegion = async () => {
            try {
                const authMetadata = await fetchAuthConfigFromBackend();
                setRegion(authMetadata.region);
                setCoreSystem(authMetadata.coreSystem);
            } catch (error) {
                const fallbackRegion = getRegion(window.location.hostname);
                setRegion(fallbackRegion);
                setCoreSystem(fallbackRegion);
            } finally {
                setIsLoadingRegion(false);
            }
        };
        loadRegion();
    }, []);

    const handleNavigateBack = () => history.push({ pathname: '/login' });

    // Show loading state while fetching region
    if (isLoadingRegion || !region || !coreSystem) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <div>Loading...</div>
            </div>
        );
    }

    return <ForgotPassword onNavigateBack={handleNavigateBack} metadata={{ coreSystem, clientUrl: `${subdomain}#` }} />;
};

export default ForgotPasswordPage;
